/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon20Regular = forwardRef('WarningTriangleIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M10.75 6.51a.75.75 0 0 0-1.5 0v3.589a.75.75 0 0 0 1.5 0v-3.59Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.91 2.32c.954-1.565 3.226-1.565 4.181 0l6.535 10.702c.997 1.632-.178 3.726-2.09 3.726H3.465c-1.914 0-3.089-2.094-2.092-3.726L7.91 2.319Zm2.901.781a.95.95 0 0 0-1.622 0L2.654 13.803a.95.95 0 0 0 .811 1.445h13.07a.95.95 0 0 0 .811-1.445L10.811 3.101Z" })));
});
